import { useSelector, shallowEqual } from 'react-redux';

export const useTranslations = () => {
  const TRANSLATION_TEXT = useSelector(
    (state: { translations: { [key: string]: string | any } }) => state.translations,
    shallowEqual
  );
  return TRANSLATION_TEXT;
};
